export default function() {
  return {
    namespaced: true,
    state: {
      showVisitorFlow: true,
      showPOIFilter: false,
      runTest: false,
      isGeolocationOn: false,
      loading: false,
      supportGeolocation: false,
      userLocation: [0, 0],
      showSupportAlert: false,
      showFailAlert: false,
      mapBoxGeoController: null,
      mapBoxGeolocationOn: false
    },
    mutations: {
      SWITCH_POI_FILTER(state, { to = false }) {
        state.showPOIFilter = to;
      },
      TEST_RUN(state) {
        state.runTest = true;
      },
      SHOW_SUPPORT_ALERT(state) {
        state.showSupportAlert = true;
      },
      DISMISS_SUPPORT_ALERT(state) {
        state.showSupportAlert = false;
      },
      SHOW_FAIL_ALERT(state) {
        state.showFailAlert = true;
      },
      DISMISS_FAIL_ALERT(state) {
        state.showFailAlert = false;
      },
      START_LOADING(state) {
        state.loading = true;
      },
      DONE_LOADING(state) {
        state.loading = false;
      },
      UPDATE_GEOLOCTION_SUPPORT(state, isSupport) {
        state.supportGeolocation = isSupport;
      },
      GEOLOCATION_ON(state) {
        state.isGeolocationOn = true;
      },
      GEOLOCATION_OFF(state) {
        state.isGeolocationOn = false;
      },
      MAPBOX_GEOLOCATION_ON(state) {
        state.mapBoxGeolocationOn = true;
      },
      MAPBOX_GEOLOCATION_OFF(state) {
        state.mapBoxGeolocationOn = false;
      },
      UPDATE_USER_LOCAITON(state, {lat, lon}) {
        state.userLocation = [lon, lat];
      },
      UPDATE_MPGC(state, {controller}) {
        state.mapBoxGeoController = controller;
      }
    },
    actions: {
      turnOnPOIFilter({commit}) {
        commit("SWITCH_POI_FILTER", {to: true});
      },
      turnOffPOIFilter({commit}) {
        commit("SWITCH_POI_FILTER", {to: false});
      },
      dismissFailAlert({commit}) {
        commit("DISMISS_FAIL_ALERT");
      },
      dismissSupportAlert({commit}) {
        commit("DISMISS_SUPPORT_ALERT");
      },
      updateUserGeolocation({state, commit}, {position}) {
        commit("UPDATE_USER_LOCAITON", {
          lat: position.coords.latitude,
          lon: position.coords.longitude,
        });

        if (state.loading) {
          commit("GEOLOCATION_ON");
          commit("DONE_LOADING");
        }
      },
      updateMPGC({commit}, {controller}) {
        commit("UPDATE_MPGC", {controller});
      },
      mapBoxGeolocationFail({commit}) {
        commit("SHOW_FAIL_ALERT");
        commit("GEOLOCATION_OFF");
        commit("DONE_LOADING");
      },
      turnOnMapBoxGeolocation({commit}) {
        commit("MAPBOX_GEOLOCATION_ON");
      },
      turnOffMapBoxGeolocation({commit}) {
        commit("MAPBOX_GEOLOCATION_OFF");
        commit("GEOLOCATION_OFF");
      },
      turnOffGeolocation({commit}) {
        commit("GEOLOCATION_OFF");
      },
      turnOnGeolocation({ state, commit }) {
        // Already check brower support
        if (state.runTest && !state.supportGeolocation) return ;

        let supportGeolocation = state.supportGeolocation;
        // Not run browser test yet
        if (!state.runTest) {
          supportGeolocation = !!(navigator && navigator.geolocation);
          commit("TEST_RUN");
          commit("UPDATE_GEOLOCTION_SUPPORT", supportGeolocation);
          !supportGeolocation && commit("SHOW_SUPPORT_ALERT");
        }

        if (supportGeolocation && !state.loading) {
          commit("START_LOADING");
          if (state.mapBoxGeoController) {
            if (!state.mapBoxGeolocationOn) {
              state.mapBoxGeoController.trigger();
            } else if (!state.showFailAlert) {
              commit("GEOLOCATION_ON");
              commit("DONE_LOADING");
            }
          } else {
            navigator.geolocation.getCurrentPosition(
              // success
              (position) => {
                commit("UPDATE_USER_LOCAITON", {
                  lat: position.coords.latitude,
                  lon: position.coords.longitude,
                });
                commit("GEOLOCATION_ON");
                commit("DONE_LOADING");
              },
              // error
              (err) => {
                commit("SHOW_FAIL_ALERT");
                commit("GEOLOCATION_OFF");
                commit("DONE_LOADING");
              },
              {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
              }
            )
          }
        }
      },
    },
  }
}